<template>
    <div>
        <h3 class="grey-color mb-3 main_text font-weight-bold">Запросы блокировок</h3>

        <b-overlay :show="isLoading" rounded opacity="0.6" spinner-variant="primary">
            <b-row class="mb-2 cabinet_filter">
                <filter-new-multiple-select v-model="filter.status" :options="$globalDictionaries.blockRequestStatuses" label="Статус запроса" label-class="grey-color" lg="6" md="6" placeholder="Выберите статус" label-field="title" />
                <b-col class="mb-1 text-right fix-pos" lg="6" md="6">
                    <b-btn class="text-uppercase ml-2" style="height: 32px; line-height: 15px" variant="custom-green" @click.prevent="getRequests(true)">НАЙТИ</b-btn>
                    <b-btn class="text-uppercase ml-2" style="height: 32px; line-height: 15px" variant="custom-outline-secondary" @click.prevent="cleanFilters">СБРОС</b-btn>
                </b-col>
            </b-row>

            <b-pagination v-if="blockRequests && meta.total > 0 && meta.last_page > 1" v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" class="my-1 py-0" />

            <cabinet-fl44-external-purchase-block-request-card v-for="blockRequest in blockRequests" :request="blockRequest" :key="blockRequest.id" />
            <empty-request v-if="!blockRequests.length && !isLoading" />

            <b-pagination v-if="blockRequests && meta.total > 0 && meta.last_page > 1" v-model="meta.current_page" :per-page="meta.per_page" :total-rows="meta.total" align="center" class="my-1 py-0" @input="getRequests()" />
        </b-overlay>
    </div>
</template>

<script>
import CabinetFl44ExternalPurchaseBlockRequestCard from '@/components/cabinet/fl44/block-requests/partials/cabinet-fl44-external-purchase-block-request-card.vue';
import FilterNewMultipleSelect from '@/components/common/filter-components/filter-new-multiple-select.vue';

const emptyFilter = {
    status: []
};

export default {
    name: 'cabinet-fl44-block-requests-list',
    components: { FilterNewMultipleSelect, CabinetFl44ExternalPurchaseBlockRequestCard },
    data() {
        return {
            blockRequests: [],
            isLoading: true,
            meta: {
                current_page: 1,
                total: 0,
                per_page: 10
            },
            filter: { ...emptyFilter }
        };
    },
    async mounted() {
        if (!this.orgRoleIsPermitted(this.$orgRoles.CUSTOMER_FL44)) {
            await this.$router.push({ name: '404' }).catch(() => {});
        }
        await this.getRequests();
        this.$scrollToTop();
    },
    methods: {
        getFilters(page = true) {
            const filterValues = [];
            for (const [key, value] of Object.entries(this.filter)) {
                if (value) {
                    filterValues[key] = value;
                }
            }
            return {
                ...filterValues,
                page: page ? this.meta.current_page : 1
            };
        },
        async getRequests(page = true) {
            this.isLoading = true;
            try {
                this.isLoading = true;
                const response = await this.$api.personal.fl44ExternalPurchases.getBlockRequestsList(this.getFilters(page));
                this.blockRequests = response.data;
                this.meta = response.meta;
            } finally {
                this.isLoading = false;
            }
        },
        async cleanFilters() {
            this.filter = { ...emptyFilter };
            await this.getRequests();
        }
    }
};
</script>
<style scoped>
.fix-pos {
    padding-top: 18px !important;
}
</style>
